import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubregionService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SubregionCreateDto,
  SubregionDto,
  SubregionExcelDownloadDto,
  SubregionUpdateDto,
} from '../proxy/planning/dtos/subregion';
import { SUBREGION_CONFIG, SUBREGION_FIELDS } from './subregion.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-subregion',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SubregionService, ConfirmationService],
  templateUrl: './subregion.html',
  styleUrl: './subregion.scss',
})
export class Subregion extends BaseHierarchicalCrudComponent<
  SubregionDto,
  SubregionCreateDto,
  SubregionUpdateDto,
  SubregionExcelDownloadDto
> {
  service = inject(SubregionService);
  config = SUBREGION_CONFIG;
  fields = SUBREGION_FIELDS;

  protected prepareUpdateDto(data: any, selected: SubregionDto): SubregionUpdateDto {
    return {
      name: data.name,
      code: data.code,
      locationId: data.locationId,
      regionId: data.regionId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Subregion';
  }
}
